<template>
    <tr class="entity-row-cs-36" v-if="!isDeleted">
        <td>
            <router-link :to="{ name: 'fire-stopping-report-view-site-plan', params: {id: item.site_fire_stopping_report_site_plan_id} }" class="d-block">
                {{ item.site_plan_title }}</router-link>
        </td>
        <td>
            <router-link :to="{ name: 'fire-stopping-report-view-site-plan', params: {id: item.site_fire_stopping_report_site_plan_id} }" class="a-primary d-block">
                View </router-link>
        </td>
        <td>
            <router-link :to="{ name: 'fire-stopping-report-edit-site-plan', params: {id: item.site_fire_stopping_report_site_plan_id} }"  class="a-info d-block">Edit</router-link>
        </td>
        <td>
            <a class="a-danger delete-entity d-block"
               v-bind:href="'#delete-item-link-' + item.site_fire_stopping_report_site_plan_id"
               v-bind:id="'delete-item-link-' + item.site_fire_stopping_report_site_plan_id"
               v-on:click="deleteItem"
               v-bind:data-item-id="item.site_fire_stopping_report_site_plan_id"
               ref="deleteButton"
            >Delete</a>
        </td>
    </tr>
</template>
<script>
    export default {
        props: ['item'],
        data() {
            return {
                isDeleted: false,
                itemToDelete: null
            }
        },
        methods: {
            deleteItem() {
                var button = this.$refs.deleteButton;
                var itemId = button.dataset.itemId;
                var vm = this;

                this.getDbNew().then(db => {
                    var reportItemId = parseInt(itemId);
                    var objectStore = db.transaction('fire_stopping_report_site_plans').objectStore('fire_stopping_report_site_plans');
                    var storeRequest = objectStore.get(reportItemId);

                    storeRequest.onsuccess = function(event) {
                        vm.itemToDelete = storeRequest.result;
                        vm.itemToDelete.is_deleted = true;

                        vm.$swal({
                            title: 'Are you sure?',
                            text: 'Are you sure you want to delete this site plan? Any issues linked to it will be removed as well. This action is irreversible!',
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: 'Yes',
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true,
                            buttons: {
                                cancel: {
                                    text: 'Cancel',
                                    value: null,
                                    visible: false,
                                    className: 'btn btn-square btn-sm btn-secondary',
                                    closeModal: true,
                                },
                                confirm: {
                                    text: 'Yes',
                                    value: true,
                                    visible: true,
                                    className: 'btn btn-square btn-sm btn-primary',
                                    closeModal: true
                                }
                            }
                        }).then((result) => {
                            if (result.value) {
                                var putRequest = db.transaction('fire_stopping_report_site_plans', 'readwrite')
                                    .objectStore('fire_stopping_report_site_plans').put(vm.itemToDelete);
                                putRequest.onsuccess = async (event) => {
                                    await vm.markLinkedIssuesAsDeleted(vm.itemToDelete.site_fire_stopping_report_site_plan_id);
                                    vm.isDeleted = true;
                                };
                                putRequest.onerror = function(event) {
                                    console.log(event);
                                };
                            }
                        });
                    };
                    storeRequest.onerror = function(e) {
                        console.log(e)
                    }
                }).catch(e => {
                    console.log(e);
                });
            },
            markLinkedIssuesAsDeleted(site_fire_stopping_report_site_plan_id) {
                return new Promise(async (resolve, reject) => {
                    await this.getDbNew().then(db => {
                        var transaction = db.transaction('fire_stopping_report_items', 'readwrite');
                        var fireStoppingReportItemsStore = transaction.objectStore('fire_stopping_report_items');

                        transaction.oncomplete = resolve;
                        transaction.onerror = function (error) {
                            reject(error);
                        };

                        if (fireStoppingReportItemsStore) {
                            var vm = this;
                            fireStoppingReportItemsStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (site_fire_stopping_report_site_plan_id == cursor.value.site_fire_stopping_report_site_plan_id) {
                                        let itemToUpdate = cursor.value;
                                        itemToUpdate.is_deleted = true;
                                        cursor.update(itemToUpdate);
                                    }
                                    cursor.continue();
                                }

                                vm.$emit('site-plan-removed', site_fire_stopping_report_site_plan_id);
                            }
                        }
                    });
                });
            },
            reload() {
                window.location = '';
            }
        }
    }
</script>